import Service from "@services/Service";
import { WEB_API_ENDPOINT } from "@utils/awsAmplify";

class Schedule extends Service {
  static list(accountId) {
    return Schedule.get(WEB_API_ENDPOINT, "/scheduled_requests", {
      queryStringParameters: {
        account_id: accountId,
      },
    });
  }

  static find(accountId) {
    return Schedule.get(WEB_API_ENDPOINT, `/scheduled_requests/${accountId}`);
  }

  static cancel(requestId) {
    return Schedule.put(
      WEB_API_ENDPOINT,
      `/scheduled_requests/${requestId}/cancel`
    );
  }
}

export default Schedule;
